module.exports = __webpack_public_path__ + "img/2_2-industriale-centrale_elettrica-1.1a7af79e.png";